var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,9.59v.82l-5.29,5.3-1.42-1.42L18.59,11H8.41L5,14.41V18H3V14l.29-.71,4-4L8,9H18.59l-3.3-3.29,1.42-1.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForward);
export default __webpack_public_path__ + "static/1765983986/media/icon-forward.5e13004ec308899941c5e9742c7e43d5.svg";
export { ForwardRef as ReactComponent };